import {
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
  Icon,
  Flex,
  useOutsideClick,
} from '@chakra-ui/react';
import { SearchMd } from '@kula-ai/icons/dual-tone/SearchMd';
import { useRef, useEffect, useState } from 'react';
import { X } from '@kula-ai/icons-core';

export const SearchFilter = ({
  filterActions = (_data) => {},
  searchTerm = '',
  hideSearchFullView = false,
  isCustomSearch = false,
  onCustomSearch = (_data) => {},
  placeholder = 'Search',
  inputStyles = {},
  inputGroupStyles = {},
}) => {
  const userInput = useRef();
  const ref = useRef(null);
  const intervalRef = useRef(null);
  const [showInput, setShowInput] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  useEffect(() => {
    if (userInput?.current) {
      userInput.current.value = searchTerm;
    }
  }, [searchTerm]);
  const inputBg = searchValue ? 'white' : 'secondary-50';
  const handleOnSearch = () => {
    clearTimeout(intervalRef.current);
    intervalRef.current = setTimeout(() => {
      if (isCustomSearch) {
        onCustomSearch(userInput.current?.value);
      } else {
        filterActions({ type: 'search', searchTerm: userInput.current?.value });
      }
    }, 300);
  };

  useOutsideClick({
    ref: ref,
    handler: () => setShowInput(false),
  });

  const defaultStyles = {
    fontSize: '12px',
    paddingInlineStart: '.75em',
    pt: '1.125em',
    pb: '1.125em',
    height: '2.75em',
    borderRadius: '8px',
  };

  return (
    <Flex alignItems="center" ref={ref}>
      {!searchTerm && !showInput && hideSearchFullView ? (
        <Flex
          w="1.75em"
          h="1.75em"
          cursor="pointer"
          alignItems="center"
          justifyContent="center"
          borderRadius="6px"
        >
          <Icon
            as={SearchMd}
            color="secondary-800"
            width="18px"
            height="18px"
            onClick={() => setShowInput((prev) => !prev)}
            cursor="pointer"
          />
        </Flex>
      ) : (
        <InputGroup width="328px" borderRadius="sm" {...inputGroupStyles}>
          <InputLeftElement
            pointerEvents="none"
            maxH="100%"
            children={<Icon as={SearchMd} color="secondary-800" width="20px" />}
          />
          <Input
            type="text"
            h="36px"
            ref={userInput}
            placeholder={placeholder}
            _placeholder={{
              opacity: 1,
              fontSize: 'sm',
              fontWeight: 'medium',
              color: 'secondary-400',
            }}
            bg={inputBg}
            borderColor="secondary-200"
            _focus={{
              bg: inputBg,
              borderColor: 'secondary-200 !important',
              boxShadow: 'none !important',
            }}
            _focusVisible={{
              bg: inputBg,
              borderColor: 'secondary-200 !important',
              boxShadow: 'none !important',
            }}
            onChange={(event) => {
              setSearchValue(event.target.value);
              handleOnSearch();
            }}
            autoFocus={showInput}
            {...defaultStyles}
            {...inputStyles}
            data-test-id="search"
          />
          <InputRightElement
            maxH="100%"
            children={
              userInput?.current?.value?.length > 0 && (
                <Icon
                  as={X}
                  w="16px"
                  h="16px"
                  cursor="pointer"
                  color="secondary-800"
                  onClick={() => {
                    userInput.current.value = '';
                    handleOnSearch();
                  }}
                />
              )
            }
          />
        </InputGroup>
      )}
    </Flex>
  );
};
